<template>
  <div class="mt-5">
    <h5>{{$t('home.missatge')}} {{titleApp}}</h5>
  </div>
</template>

<script>
export default {
  name: "home",
  computed: {
    titleApp(){
      return process.env.VUE_APP_TITLE;
    }
  },  
  data() {
    return {

    };
  },
  methods: {
 
  },
  mounted() {

  }
};
</script>

<style>
</style>